<template lang="html">

  <section class="src-components-main">
    <router-view
            v-on:refresh-header="refreshHeader()"></router-view>
  </section>

</template>

<script lang="js">
export default  {
    name: 'src-components-main',
    components: {},
    props: [],
    mounted() {
    },
    data() {
      return {

      }
    },
    methods: {
      refreshHeader() {
        this.$emit('refresh-header');
      }
    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
  .src-components-main {

  }
</style>
